<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.carCode" label="物流发车单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.orderNo" label="原料果转运单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.farmName" label="种植园名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

<!--        <van-field v-model="inputForm.rawTeamName" label="采摘中心小组" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />-->
        <van-field v-model="inputForm.rawOperatorName" label="采摘负责人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractCode" label="收购合同编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.companyName" label="贸易公司名称（合同甲方）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.requirement1" label="底部糖度要求" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.estimateWeight" label="合同预估采摘重量（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.pickedWeight" label="已采摘重量（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remainWeight" label="剩余预估重量（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.payMethod" label="付款方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.requirement2" label="单粒克重" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.teamName" label="原料采摘组" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="代办人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.agencyLinkPerson" label="代办人联系方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departDate" label="发车日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departName" label="发车地点" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.varietyName" label="收购品种" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.teamName" label="采购中心小组" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="采摘组长" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </div>

      <van-collapse-item title="原料果转运装车信息" name="1">
<!--        <van-field v-model="inputForm.weighFlagLabel" label="是否分开称重" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />-->
        <van-field v-model="inputForm.contractDeposit" label="合同约定订金（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.alreadyPaidDeposit" label="已支付订金（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remainDeposit" label="剩余可抵扣订金（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckWeightEmpty" label="空车过磅重量（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckWeight" label="装车过磅总重（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.varietyGrossWeight" label="含筐总重（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckNum" label="装车总件数（筐）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.eachPackWeight" label="单车包装材料总重（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.varietyNetWeight" label="不含筐总重（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractHarvestLossRate" label="合同约定果损（%）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
<!--        <van-field v-model="inputForm.varietyPrice" label="产品单价（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />-->
        <van-field v-model="inputForm.eachLoseWeight" label="每车果损率重量（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.settleNetWeight" label="单车结算重量（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <van-field v-model="inputForm.truckFeeTheory" label="单车结算金额（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />


<!--        <van-field v-model="inputForm.truckFee" label="实付金额（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />-->
        <van-field v-model="inputForm.depositFee" label="订金抵货款（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckFeeActual" label="扣除订金后应付金额（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
<!--        <van-field v-model="inputForm.otherLaborDaily" label="对方原料果采摘劳务用工（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />-->
        <van-field v-model="inputForm.paidAmount" label="实付金额（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.depositBalance" label="订金余额（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.finishStatusLabel" label="是否完结" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.settlementAttachList.length > 0">
          <p style="color: #AAA">结算单附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.settlementAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
          <p style="display: block; color: #4caedc" @click="viewDetail()">查看明细</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="原料果转运过磅信息" name="2">
        <van-field v-model="inputForm.weighFee" label="过磅费（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.weighFeeAttachList.length > 0">
          <p style="color: #AAA">过磅小票</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.weighFeeAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="原料果转运发车信息" name="3">
        <van-field v-model="inputForm.departAddress" label="发车详细地址" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.rawFruitSellerName" label="原料果出售人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.rawFruitSellerPhone" label="原料果出售人联系方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckTypeLabel" label="车型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckLengthLabel" label="厢长" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckDriverName" label="货车司机" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckDriverPhone" label="司机联系方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.plateNo" label="原料果转运车牌号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.departAttachList.length > 0">
          <p style="color: #AAA">车头照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.departAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.departBodyAttachList.length > 0">
          <p style="color: #AAA">车身照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.departBodyAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.departTailAttachList.length > 0">
          <p style="color: #AAA">车尾照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.departTailAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="原料果转运收货信息" name="4">
        <van-field v-model="inputForm.consignName" label="收货地点" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.consignAddress" label="收货详细地址" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.consignLinkPerson" label="收货联系人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.consignLinkPhone" label="收货人联系方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remark" label="备注" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
export default {
  name: "ItsOrderDepartRaw",
  data(){
    return {
      activeNames: ['1','2','3','4'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        settlementAttachList: [],
        weighFeeAttachList: [],
        departAttachList: [],
        departBodyAttachList: [],
        departTailAttachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_order_depart_raw'
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/order/itsOrderDepartRaw/queryById').then(({ data }) => {
        this.inputForm = data
        // this.inputForm.weighFlagLabel = this.inputForm.weighFlag === '1' ? '是' : '否'
        if(!data.weighFeeAttachList) {
          this.inputForm.weighFeeAttachList = []
        }
        this.getDict([
          ['its_comm_flag', 'finishStatus'],
          ['its_comm_truck_type', 'truckType'],
          ['its_comm_truck_length', 'truckLength'],
        ])
        this.updateDictNames(this.inputForm.detailList,{its_base_variety_level:'varietyLevel'})
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    },
    viewDetail(){
      this.$router.push({
        path: '/ItsOrderDepartRawDetail',
        query: {
          data: JSON.stringify(this.inputForm.detailList)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
